import { memo, useCallback, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import SelectItemWithDescription, {
  ItemWithDescription,
} from "@coworker/apprestructured/src/task-management/components/SelectItemWithDescription/SelectItemWithDescription";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";

const items: ItemWithDescription[] = [
  {
    label: "Item 1 with required description",
    value: "item1",
    requireDescription: true,
  },
  {
    label: "Item 2",
    value: "item2",
    requireDescription: false,
  },
  {
    label: "Item 3 with required description",
    value: "item3",
    requireDescription: true,
  },
  {
    label: "Item 4",
    value: "item4",
    requireDescription: false,
  },
];

function SelectItemWithDescriptionDemo() {
  const [item, setItem] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [disabled, setDisabled] = useState(false);
  const [title, setTitle] = useState<string>("Title");

  const handleConfirmClick = useCallback(
    (newItem: { value: string; description: string }) => {
      setItem(newItem.value);
      setDescription(newItem.description);
    },
    []
  );

  return (
    <Demo>
      <Name>SelectItemWithDescription</Name>
      <Highlight>
        <FixaListView id="SelectItemWithDescription" size="small">
          <SelectItemWithDescription
            items={items}
            value={item}
            label={item}
            description={description}
            onConfirmClick={handleConfirmClick}
            disabled={disabled}
            title={title}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="SelectItemWithDescription-disabled"
          id="SelectItemWithDescription-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaInputField
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
      </Actions>
    </Demo>
  );
}

export default memo(SelectItemWithDescriptionDemo);
